import React from "react";
import { GameContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import { setReduxWallet } from "store/reducers/walletReducer";
import { AlertControl } from "components/Modals/Alert";
import { ROUTE_PATH } from "utils/constants/routePath";
import { SpinWheelWidget } from "widgets";
import { withTranslation } from "react-i18next";
import { Displays, Headers, Navigations } from "components";

class GameContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchReward();
  }

  fetchReward = async () => {
    let res = await userService.GET_LUCKY_DRAW_LIST(
      `?is_active=true&pagination=false`,
    );
    if (res && res.status === 200) {
      this.setState({
        rewardData: [
          // {
          //   id: false,
          //   option: 'ไม่ได้ของรางวัล',
          //   style: {
          //     backgroundColor: '#ff0000',
          //     textColor: 'white',
          //   },
          // },
          ...res.data.docs.map((e, i) => ({
            id: e._id,
            option: e.name,
            style: {
              backgroundColor: (i + 1) % 2 === 0 ? "#4B1E78" : "yellow",
              textColor: "black",
            },
          })),
        ],
        isLoading: false,
      });
    }
  };

  handleClickSpinWheel = async (e) => {
    const { walletRedux } = this.props;
    const { rewardData } = this.state;
    this.fetchReward();
    this.props.setReduxWallet({
      ...walletRedux,
      coin: walletRedux.coin - 1,
    });
    if (!rewardData[e].id) {
      AlertControl.show({
        title: "Sorry",
        description: "You not have reward",
        btnLabel2: "OK",
      });
    } else {
      AlertControl.show({
        title: "ยินดีด้วย",
        description: `คุณได้รับ ${rewardData[e].option}`,
        btnLabel2: "ตกลง",
      });
    }
  };

  render() {
    const { t } = this.props;
    const { isLoading, rewardData } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Survey", { ns: "common" }),
        path: ROUTE_PATH.SPECIAL_POINTS,
      },
      {
        name: t("Game", { ns: "common" }),
      },
    ];
    return (
      <GameContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="game_container">
          <div className="header_sec">
            <Headers.NewPageHeader title={"GAME LUCKY DRAW"} sub_title={"เกมส์"} />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <SpinWheelWidget
              data={rewardData}
              onSpinSuccess={this.handleClickSpinWheel}
            />
          )}
        </div>
      </GameContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
  walletRedux: state.walletRedux,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxWallet: (data) => dispatch(setReduxWallet(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common"])(withRouter(GameContainer)));
